<template>
  <div class="topscreen-wrapper">
    <header class="pb-lg-0 header">
      <div class="navbar-container">
        <Navbar/>
      </div>
    </header>
    <slot/>
  </div>
</template>
<script>
import Navbar from "./Navbar";

export default {
  name: "Header",
  components: {Navbar}
}
</script>
<style lang="scss">
@import "src/scss/colors";

.topscreen-wrapper {
  background-color: $gray-dark;
  @media (min-width: 992px) {
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('/img/bg-green-dots.svg');
    background-position: left center;
  }
  @media (max-width: 1100px) {
    background-size: cover;
  }
}

.header {
  background-color: $black;
  padding: 35px 0;
  margin-bottom: -1px;
  @media (min-width: 576px) {
    padding: 30px 0 70px;
  }
  @media (min-width: 992px) {
    background-color: transparent;
  }

  .navbar-container {
    padding-left: 15px;
    padding-right: 15px;

    @media (min-width: 576px) {
      padding-left: 30px;
      padding-right: 30px;
    }
    @media (min-width: 1920px) {
      padding-left: 80px;
      padding-right: 80px;
    }
  }
}
</style>